import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import { Suspense, lazy } from 'preact/compat';
const SelectGroup = lazy(
    () => import(/* webpackChunkName: "select-group" */ '../../../shared/form/select-group')
);

const timezones = {
    '-10.00': 'Hawaii (GMT -10:00)',
    '-9.00': 'Alaska (GMT -09:00)',
    '-8.00': 'Pacific Time (GMT -08:00)',
    '-7.00': 'Mountain Time (GMT -07:00)',
    '-6.00': 'Central Time (GMT -06:00)',
    '-5.00': 'Eastern Time (GMT -05:00)',
    '-4.00': 'Atlantic (GMT -04:00)',
    '-3.50': 'Newfoundland Time (GMT -03:30)',
    '-3.00': 'Buenos Aires (GMT -03:00)',
    '-2.00': 'Mid-Atlantic (GMT -02:00)',
    '-1.00': 'Azores (GMT -01:00)',
    '0.00': 'London (GMT)',
    '1.00': 'Paris (GMT +01:00)',
    '2.00': 'Athens (GMT +02:00)',
    '3.00': 'Moscow (GMT +03:00)',
    '4.00': 'Abu Dhabi (GMT +04:00)',
    '5.00': 'Bombay (GMT +05:00)',
    '5.50': 'New Delhi (GMT +05:30)',
    '6.00': 'Almathy (GMT +06:00)',
    '6.50': 'Burma (GMT +06:30)',
    '7.00': 'Bangkok (GMT +07:00)',
    '8.00': 'Hong Kong | Perth (GMT +08:00)',
    '9.00': 'Tokyo (GMT +09:00)',
    '9.50': 'Adelaide (GMT +09:30)',
    '10.00': 'Sydney (GMT +10:00)',
    '11.00': 'Magadan (GMT +11:00)',
    '12.00': 'Auckland | Fiji (GMT +12:00)',
    '-11.00': 'Midway (GMT -11:00)',
};

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        this.state = {
            timezone: {
                value: props.user.timezone,
                error: false,
            },
        };
    }

    render(props, { timezone }) {
        return (
            <time-zone>
                <Suspense fallback={<div className='skeleton' />}>
                    <SelectGroup
                        name='timezone'
                        value={timezone.value}
                        placeholder='SELECT TIME ZONE'
                        options={timezones}
                        error={timezone.error}
                        onChange={this.handleChange}
                    />
                </Suspense>
            </time-zone>
        );
    }

    handleChange = (e) => {
        const state = {
            [e.target.name]: {
                value: e.target.value,
                error: false,
            },
        };

        this.setState(state);

        this.props.onChange(e.target.name, e.target.value, false);
    }
}

const mapStateToProps = (state) => ({
    user: state.user,
});

export default connect(mapStateToProps)(Component);
